import React, {useContext, useEffect, useMemo, useState} from 'react';
import styles from "./Friends.module.scss";
import MyCenterMenuLayout from "../../layouts/MyCenter/MenuLayout";
import {Layout, List, Skeleton, Tabs,} from "antd";
import {useTranslation} from "react-i18next";
import * as FriendAPI from "../../service/friend.service";
import _ from "lodash";
import SkeletonCard from "../../pages/Profile/Friends/SkeletonCard";
import FriendCard from "../../pages/Profile/Friends/FriendCard";
import NoData from "../shared/NoDataDisplay/NoData";
import InfiniteScroll from "react-infinite-scroll-component";
import AddFriendPopup from "../../pages/Profile/Friends/AddFriendPopup";
import useFetch, {CachePolicies} from "use-http";
import BlockFriend from "./BlockFriend";
import ProfilePopup from "../../pages/Profile/ProfilePopup/ProfilePopup";
import ReportedHistory from "./ReportedHistory";
import {AppContext} from "src/pages/context/App.context";
import CenterButton from "../shared/button/CenterButton";

const { Content, Header } = Layout
const { TabPane } = Tabs

interface FriendsProps {

}

const callLimit = -1;
const reportLimit = 10;

export const Friends: React.FunctionComponent<FriendsProps> = (props) => {
    const { t } = useTranslation();

    const appCtx: any = useContext(AppContext);
    const [myFriends, setMyFriends] = useState<any>(null);
    const [favoriteFriends, setFavoriteFriends] = useState<any>(null);
    const [blockAccounts, setBlockAccounts] = useState<any[]>([]);
    const [reportedHistory, setReportedHistory] = useState<any[]>([]);
    const [totalReport, setTotalReport] = useState<number>(0);
    const [countFriends, setCountFriends] = useState<number>(0);
    const [hasMoreFriend, setHasMoreFriend] = useState<boolean>(true);
    const [showModalAddFriend, setShowModalAddFriend] = useState<boolean>(false);
    const [showModalProfile, setShowModalProfile] = useState<boolean>(false);
    const [currentFriendId, setCurrentFriendId] = useState<string>();
    const [newFriend, setNewFriend] = useState<any>(null);
    const noDataHeaderText = t("No friend available");
    const nodatatext = t("When have friend in center they'll appear on this pages");

    const blockAccount = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/all/block-account`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const unblockAccount = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/unblock-friend`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const reportAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/report/?type=user`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );


    const getReportedHistory = async () => {
        const res = await reportAPI.get(`&limit=${reportLimit}&offset=${reportedHistory.length}`);
        if (res?.code) return
        setTotalReport(res?.total);
        setReportedHistory((prev) => [...prev, ...res?.reports]);
    };

    const unblock = (friendID: string) => {
        unblockAccount.post({ friendID })
            .then(r => {
                if (r?.code) return
                getBlockAccounts();
                getFriends();
            })
            .catch((e) => {

            })
    }

    const loadMyFriend = async (
        search: string,
        limit: number,
        offset: number
    ) => {
        const { data } = await FriendAPI.findMyFriend(search, limit, offset);
        return data;
    };

    const checkHasMore = (currentTotal: number, total: number) => {
        setHasMoreFriend(false);
        // if (currentTotal + callLimit >= total) setHasMoreFriend(false);
    };

    const getBlockAccounts = async () => {
        const data = await blockAccount.get(``);
        setBlockAccounts(data);
    };

    useEffect(() => {
        getFriends();
        getBlockAccounts();
        getReportedHistory();
    }, []);

    const getFriends = async () => {
        const data = await loadMyFriend("", callLimit, 0);
        const fav_data = data?.data.filter((data: any, idx: number) => {
            return idx < 3;
        });

        setMyFriends(data);
        setFavoriteFriends(fav_data);
        checkHasMore(data?.data?.length, data?.total);
        setCountFriends(data.total);
    };

    const fetchNextFriends = async () => {
        console.log("loading more...");

        checkHasMore(myFriends?.data?.length, myFriends?.total);

        if (myFriends?.data?.length < myFriends?.total) {
            const comingData = await loadMyFriend(
                "",
                callLimit,
                myFriends?.data?.length
            );

            setMyFriends((prev: any) => {
                const newFriendsData = {
                    data: [...prev.data, ...comingData.data],
                    total: prev.total,
                };
                return newFriendsData;
            });
        }
    };

    const hasMoreReport = useMemo(() => {
        return reportedHistory.length < totalReport
    }, [totalReport, reportedHistory])

    // const fetchNextReports = async () => {
    //     getReportedHistory
    //     setFindFriend((prev: any) => {
    //         const newData = {
    //             data: [...prev.data, ...comingData.data],
    //             total: prev.total,
    //         };
    //         return newData;
    //     });
    // };

    const currentFriend = useMemo(() => {
        return myFriends?.data?.find((friend: any) => friend?.friend?.id === currentFriendId)
    }, [currentFriendId])

    useEffect(() => {
        console.log("currentFriendId", currentFriendId)
    }, [currentFriendId])

    useEffect(() => {
        console.log("currentFriend", currentFriend)
        if (currentFriend) {
            setShowModalProfile(true)
        } else {
            setShowModalProfile(false)
        }
    }, [currentFriend])

    useEffect(() => {
        if (!showModalProfile) {
            setCurrentFriendId("");
        }
    }, [showModalProfile])

    const updateFriendList = () => {
        setMyFriends((prev: any) => {
            const newFriendObj = { friend: appCtx.newFriend };

            const newFriendsData = {
                data: [newFriendObj, ...prev.data],
                total: prev.total,
            };
            return newFriendsData;
        });

        setNewFriend(null);
    };

    useEffect(() => {
        if (appCtx.newFriend !== null) {
            updateFriendList();
        }
    }, [appCtx.newFriend]);

    useEffect(()=>{
        setCountFriends(appCtx.myFriends?.data?.length);
    },[appCtx.myFriends])

    const clickTabMain = (key: any, e: any) => {
        if (key === "1") { appCtx.setTabsFriends("Friends") };
        if (key === "2") { appCtx.setTabsFriends("Blocked Accounts") };
        if (key === "3") { appCtx.setTabsFriends("Reported History") };
    }
    return (
        <MyCenterMenuLayout headerPostfix={<CenterButton
            small
            onClick={() => {
                setShowModalAddFriend(true)
            }}
            style={{
                marginLeft: "3rem"
            }}
        >
            {t("Add friend")}
        </CenterButton>}>
            <ProfilePopup
                show={showModalProfile}
                onClose={() => {
                    setShowModalProfile(false)
                }}
                // onShowConfirmBlock={() => {
                //     // setShowConfirmBlock(true);
                // }}
                onBlock={(friendID: string) => {
                    setShowModalProfile(false);
                    setMyFriends((prev: any) => {
                        let newFriendsData = {
                            data: prev?.data?.filter((f: any) => f?.friend?.id !== friendID),
                            total: prev.total,
                        };
                        newFriendsData.total = newFriendsData?.data.length
                        return newFriendsData;
                    });
                    getBlockAccounts();
                }}
                onReport={() => { }}
                profile={currentFriend?.friend}
            />
            <AddFriendPopup show={showModalAddFriend} close={() => setShowModalAddFriend(false)} />
            <Content>
                <Tabs defaultActiveKey="1" onTabClick={clickTabMain}>
                    <TabPane tab={t("Friends") + ` (${countFriends || 0})`} key="1">
                        <div
                            id="friends-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '0 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={myFriends && myFriends?.data?.length > 0 ? myFriends?.data.length : 0}
                                next={fetchNextFriends}
                                hasMore={true}
                                scrollableTarget={"friends-div"}
                                loader={
                                    !hasMoreFriend ? null : (
                                        <div className={styles.loadingCardFriend}>
                                            <SkeletonCard />
                                        </div>
                                    )
                                }
                            >
                                <div>
                                    <br></br>
                                    <div className={styles.cardFriend}>
                                        {!_.isEmpty(myFriends) ? (
                                            appCtx.myFriends?.data ? appCtx.myFriends?.data?.map((friend: any, idx: number) => {
                                                return (
                                                    <FriendCard
                                                        id={friend?.friend?.id}
                                                        key={idx}
                                                        image={friend.friend?.imageProfileURL}
                                                        firstname={friend.friend?.firstname}
                                                        lastname={friend.friend?.lastname}
                                                        // onClick={() => {
                                                        // }}
                                                        onClick={() => setCurrentFriendId(friend?.friend?.id)}
                                                    />
                                                );
                                            })
                                                :
                                                myFriends?.data?.map((friend: any, idx: number) => {
                                                    return (
                                                        <FriendCard
                                                            id={friend?.friend?.id}
                                                            key={idx}
                                                            image={friend.friend?.imageProfileURL}
                                                            firstname={friend.friend?.firstname}
                                                            lastname={friend.friend?.lastname}
                                                            // onClick={() => {
                                                            // }}
                                                            onClick={() => setCurrentFriendId(friend?.friend?.id)}
                                                        />
                                                    );
                                                })
                                        ) : (
                                            null
                                        )}
                                    </div>
                                    {myFriends?.data?.length === 0 && (
                                        <NoData header={noDataHeaderText} detail={nodatatext} />
                                    )}
                                    {appCtx.myFriends?.data?.length === 0 && (
                                        <NoData header={noDataHeaderText} detail={nodatatext} />
                                    )}
                                </div>
                            </InfiniteScroll>
                        </div>
                    </TabPane>
                    <TabPane tab={t("Blocked Accounts") + ` (${blockAccounts.length})`} key="2">
                        <div
                            id="blocked-accounts-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '0 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={blockAccounts.length}
                                next={() => { }}
                                hasMore={false}
                                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                                // endMessage={<Divider style={{ margin: 0}} plain></Divider>}
                                scrollableTarget="blocked-accounts-div"
                            >
                                <List
                                    className="demo-loadmore-list"
                                    // loading={initLoading}
                                    itemLayout="horizontal"
                                    // loadMore={loadMore}
                                    dataSource={blockAccounts}
                                    renderItem={(blocked: any) => (
                                        <BlockFriend
                                            id={blocked?.friend?.id}
                                            imgProfileURL={blocked?.friend?.imageProfileURL}
                                            name={`${blocked.friend?.firstname} ${blocked?.friend?.lastname ? blocked?.friend?.lastname : ""}`}
                                            date={blocked?.updatedAt}
                                            onUnblock={unblock}
                                        />
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                    </TabPane>
                    <TabPane tab={t("Reported History") + ` (${totalReport})`} key="3">
                        <div
                            id="reported-history-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '0 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={reportedHistory.length}
                                next={getReportedHistory}
                                hasMore={hasMoreReport}
                                loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                                // endMessage={<Divider style={{ margin: 0}} plain></Divider>}
                                scrollableTarget="reported-history-div"
                            >
                                <List
                                    className="demo-loadmore-list"
                                    // loading={initLoading}
                                    itemLayout="horizontal"
                                    // loadMore={loadMore}
                                    dataSource={reportedHistory}
                                    renderItem={(reported: any) => (
                                        <ReportedHistory
                                            id={reported?.user?.id}
                                            name={`${reported.user?.firstname} ${reported?.user?.lastname ? reported?.user?.lastname : ""}`}
                                            imgProfileURL={reported?.user?.imageProfileURL}
                                            date={reported?.updatedAt}
                                            reportTopic={reported?.reportTopic}
                                        />
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                    </TabPane>
                </Tabs>
            </Content>
        </MyCenterMenuLayout>
    )
}